import { module } from 'modujs';
import gsap from "gsap";


export default class extends module {
    constructor(m) {
        super(m);
        /*this.isOpen = false;
        this.path = document.querySelector( '[data-main-menu-overlay] path' );
        this.el.addEventListener( 'click', () => {
            this.isOpen = ! this.isOpen;
            this.isOpen ? this.show() : this.hide();
        });*/
    }
    hide(){
        this.el.click();
    }


}
